<template>
  <div>
    <!-- Commandes Vacances -->
    <OrdersIResaList :customer="content" />

    <PromotionCodeList :customer="content" />

    <ReferralsList :customer="content" />
  </div>
</template>

<script>
import OrdersIResaList from '@/components/profile/OrdersIResaList';
import ReferralsList from '@/components/profile/ReferralsList';
import PromotionCodeList from '@/components/profile/labalaguere/PromotionCodeList';

export default {
  name: 'ProfileTransactions',
  components: {
    OrdersIResaList,
    ReferralsList,
    PromotionCodeList
  },
  props: {
    content: {
      type: Object,
      default: null
    }
  }
};
</script>
